// src/admin/adminlogin.js
import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, IconButton, InputAdornment, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css'; // Import your styles here
import axios from 'axios';
import { Link } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import BASE_URL  from '../config';
const userTypes = [
  { id: 1, label: 'Super Admin' },
  { id: 2, label: 'Admin' },
  { id: 3, label: 'Staff' }
];
const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [userType, setUserType] = useState('admin'); // default
    const [userTypeId, setUserTypeId] = useState(2); // default Admin
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loginError, setLoginError] = useState('');
    const navigate = useNavigate();
    const handleLogin = async  (e) => {
        e.preventDefault();
        const validationErrors = {};
        // Validate username/email
        if (!username) {
            validationErrors.username = 'Username or Email is required';
        }
        // Validate password
        if (!password) {
            validationErrors.password = 'Password is required';
        }
        // If there are errors, update the state and return
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            const response = await axios.post(`${BASE_URL}/api/admin/login`, {
                email: username,
                password: password,
                userType,
                userTypeId

            });
          if (response.data.success) {

const {
Reg_Id,
Full_Name,
Email,
User_type,
User_type_Id
}=response.data;

sessionStorage.setItem(
'adminRegId',
Reg_Id
);

sessionStorage.setItem(
'adminName',
Full_Name
);

sessionStorage.setItem(
'adminEmail',
Email
);

sessionStorage.setItem(
'userTypeId',
User_type_Id
);

sessionStorage.setItem(
'adminUserType',
User_type
);

sessionStorage.setItem(
'adminLoginTime',
Date.now()
);

if(Number(User_type_Id)===1){

navigate('/superadmin-dashboard');

}
else if(Number(User_type_Id)===3){

navigate('/staff/home');

}
else{

navigate('/admin/home');

}
}
        } catch (error) {
            setLoginError('Invalid email or password');
        } 
    };
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
      const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };
    return (
        <div className="admin-login-page">
      <div className="admin-login-container">
        <Container maxWidth="xs" sx={{ marginTop: 4 }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Admin Login
            </Typography>
            <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                <TextField
              select
              label="User Type"
              fullWidth
              value={userType}
              margin="normal"
              onChange={(e) => {
                setUserType(e.target.value);
                const selected = userTypes.find(u => u.label.toLowerCase() === e.target.value);
                setUserTypeId(selected?.id);
              }}
            >
              {userTypes.map((u) => (
                <MenuItem key={u.id} value={u.label.toLowerCase()}>
                  {u.label}
                </MenuItem>
              ))}
            </TextField>
                <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Username or Email"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    error={!!errors.username}
                    helperText={errors.username}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Password"
                    //type="password"
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      //id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!errors.password}
                    helperText={errors.password}
                />
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                    Log In
                </Button>
                {/* Links side by side */}
                {loginError && (
                            <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
                                {loginError}
                            </Typography>
                        )}
                <Box
                            sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}
                        >
                            <Link to="/" variant="body2">
                                Home
                            </Link>
                        </Box>
            </Box>
        </Container>
        </div>
        </div>
    );
};
export default AdminLogin;
